export default __webpack_public_path__ + "static/media/0353.739193cf.jpg";